/**
 * Mapping from Business Use Case to Program for the AstraZeneca flow.
 *
 * When a user selects a Use Case, the Program field is auto-filled using
 * this mapping. If the Use Case is not present in this map, the Program
 * defaults to DEFAULT_PROGRAM ('BAU') and remains editable by the user.
 */
export const USE_CASE_PROGRAM_MAPPING: Record<string, string> = {
  'Asset Digital Twin': 'Autonomous Manufacturing',
  'Asset Intelligence': 'Autonomous Manufacturing',
  'Batch Release Visualisation': 'Autonomous Manufacturing',
  'Cognite Asset Twin': 'Autonomous Manufacturing',
  'Digital Tier': 'Autonomous Manufacturing',
  'Digital Twin': 'Autonomous Manufacturing',
  'Executive Dashboard': 'Autonomous Manufacturing',
  'Factory Flow Visualisation (Wuxi)': 'Autonomous Manufacturing',
  'Factory Foundations': 'Autonomous Manufacturing',
  'Insights Agent': 'Autonomous Manufacturing',
  'Performance Dashboard': 'Autonomous Manufacturing',
  'Process Intelligence': 'Autonomous Manufacturing',
  'SMART Metering': 'Autonomous Manufacturing',
  Tulip: 'Autonomous Manufacturing',
  Yield: 'Autonomous Manufacturing',
  'Zoladex Yield Dashboard': 'Autonomous Manufacturing',
  'CPV Reporting - Sweden Respiratory': 'Autonomous Manufacturing',
  'Blending Model': 'AIDA',
  'Coating Model': 'AIDA',
  'CDC Multi-Agent System': 'AIDA',
  'ChemDev Multi-Agent System': 'AIDA',
  'Chemical Development': 'AIDA',
  'Chemical Development Knowledge Graph': 'AIDA',
  'Feeder Model': 'AIDA',
  'Formulation Composition Knowledge Graph': 'AIDA',
  'GenAI AI Assisted Business Review': 'AIDA',
  'GenAI CDC Assistant': 'AIDA',
  'GenAI Kinetics Web App': 'AIDA',
  'GenAI PTK - Zoladex': 'AIDA',
  'Global Product Development': 'AIDA',
  'GPD Equipment Booking App': 'AIDA',
  'Material Design Knowledge Graph': 'AIDA',
  'Process Manager': 'AIDA',
  'PT&D Dashboards': 'AIDA',
  TOSI: 'AIDA',
  'Virtual Tablet Designer': 'AIDA',
  'Forecasting dashboard': 'Digital Supply Network Collaboration',
  AERA: 'Self Healing Supply Chain',
  'Demand Day Dashboard': 'Self Healing Supply Chain',
  'Demand Month Dashboard': 'Self Healing Supply Chain',
  'DVMI Dashboard': 'Self Healing Supply Chain',
  'External Sales Forecast': 'Self Healing Supply Chain',
  'FG Safety Stock': 'Self Healing Supply Chain',
  'GSC - Sales': 'Self Healing Supply Chain',
  'Material Management': 'Self Healing Supply Chain',
  'Project 44': 'Self Healing Supply Chain',
  Resilinc: 'Self Healing Supply Chain',
  'Sales Budgets': 'Self Healing Supply Chain',
  'Stock Out': 'Self Healing Supply Chain',
  'Supply Chain Chat': 'Self Healing Supply Chain',
  'Transport Lead Time Dashboard': 'Self Healing Supply Chain',
  'Transportation Lead Time': 'Self Healing Supply Chain',
  'Sustainability Assistant': 'Sustainability',
  'Sustainability Control Tower': 'Sustainability',
  'External Reporting (Workiva)': 'Sustainability',
  'Physical Properties Passport': 'AIDA',
  'APSD Dashboard': 'BAU',
  'Clinical Supply Chain - Data Driven Decision Making': 'BAU',
  'Freight S&OP': 'BAU',
  'Logistics Planning': 'BAU',
  Other: 'BAU',
  'Stability Dashboard': 'BAU',
};

/**
 * Default Program value for Use Cases not present in USE_CASE_PROGRAM_MAPPING.
 * When this default is used, the Program field remains editable by the user.
 */
export const DEFAULT_PROGRAM = 'BAU';
